// extracted by mini-css-extract-plugin
export default {"muted":"Title_muted__KOW5W","status":"Title_status__NKCoF"};